import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Modal } from "react-bootstrap";

// img
import p1 from "../../../../Assets/images/p1.png";
import { useNavigate, useParams } from "react-router-dom";
import {
  BOOKING_REJECT,
  BOOKING_ACCEPT,
  BOOKING_DETAILS,
} from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import moment from "moment";
import MakeOfferPop from "../../Booking/Modals/MakeOfferPop";
import ImagePreview from "../../../../components/Common/ImagePreview";

const ManageBookingDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [showModalView, setShowModalView] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModalView(true);
  };

  const handleModalClose = () => {
    setShowModalView(false);
    setSelectedImage(null);
  };
  const [data, setData] = useState();
  const [Offer, setOffer] = useState();
  // const userHasMadeOffer = data?.userHasMadeOffer;

  const getData = async () => {
    try {
      const res = await BOOKING_DETAILS(id);

      if (res?.data?.status === "success") {
        setData(res?.data?.data);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };
  // const handleOffer = () => setOffer(!Offer);

  // const handleOffer = () => setOffer(!Offer);
  const handleOffer = async (e) => {
    e.preventDefault();

    const body = { bookingId: id };
    try {
      const res = await BOOKING_ACCEPT(body);
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        // setOfferMade(true);
        // navigate("/booking/booking-request");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
    // makeOfferHandler();
  };

  const acceptRejectHandler = async (type) => {
    try {
      let res;
      const body = { bookingId: id };
      // if (type === "accept") {
      //   res = await ACCEPT_BOOKING(body);
      // }
      if (type === "reject") {
        res = await BOOKING_REJECT(body);
      }
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        // navigate("/booking/booking-request");
      } else {
        toast.success(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  // const acceptRejectHandler = async (type) => {
  //   try {
  //     let res;
  //     const body = { bookingId: id };
  //     if (type === "accept") {
  //       res = await BOOKING_ACCEPT(body);
  //     }
  //     if (type === "reject") {
  //       res = await BOOKING_REJECT(body);
  //     }
  //     if (res?.data?.status === "success") {
  //       toast.success(res?.data?.message);
  //       navigate("/booking/booking-request");
  //     } else {
  //       toast.success(res?.data?.message);
  //     }
  //   } catch (error) {
  //     toast.error("something went wrong");
  //   }
  // };

  useEffect(() => {
    if (id) getData();
  }, [id]);

  const PICKUP_SIZES = [
    { label: "Small (S): 0 - 10 lbs", value: "S" },
    { label: "Medium (M): 11 - 25 lbs", value: "M" },
    { label: "Large (L): 26 - 50 lbs", value: "L" },
    { label: "Extra Large (XL): 51 - 100 lbs", value: "XL" },
    { label: "2*Extra Large (XXL): > 100 lbs", value: "XXL" },
  ];
  const pickupSize = PICKUP_SIZES.find(
    (size) => size.value === data?.pickUp?.pickUpType.size
  );
  return (
    <>
      <MakeOfferPop
        Offer={Offer}
        setOffer={setOffer}
        makeOfferHandler={() => acceptRejectHandler()}
      />
      <section className="bookingDetail py-3 position-relative">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12" className="my-2">
              <div className="py-2">
                <div className="cardCstm p-3 rounded bg-white">
                  <div className="head m-0 mb-2">
                    <h4 className="m-0 fw-bold themeBlue">Pickup Details</h4>
                  </div>
                  <Row className="border-bottom">
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Name:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp?.pickUpContactName}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Contact Number:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp?.pickUpContactNumber}
                        </p>
                      </div>
                    </Col>
                    {/* <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Pickup Type:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp?.pickUpType.size} 
                        </p>
                      </div>
                    </Col> */}
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Pickup Size:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp ? `${data?.pickUp?.pickUpType?.weight}(lb)` : ""}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Booking ID:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.bookingNumber}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Pickup Date
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {moment(data?.pickUp?.pickUpDate).format(
                            "MM/DD/YYYY"
                          )}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Pickup Time:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {moment(data?.pickUp?.pickUpTime, "HH:mm:ss").format(
                            "hh:mm A"
                          )}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Vehicle Type
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.serviceType}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Vehicle
                        </label>
                        <p className="m-0 fw-bold themeClr">{data?.services}</p>
                      </div>
                    </Col>

                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Pickup Location:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp?.address}
                        </p>
                      </div>
                    </Col>

                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Booking Type:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.bookingTypeRequest === "normal" ? "Instant" : "Bidding"}
                        </p>
                      </div>
                    </Col>

                  </Row>
                  <div className="py-2">
                    <h6 className="m-0 fw-bold themeBLue">Additional Notes</h6>
                    <p className="m-0">{data?.pickUp?.additionalNotes}</p>
                  </div>
                </div>
              </div>
              <div className="py-2">
                <div className="cardCstm p-3 rounded bg-white">
                  <div className="head m-0 mb-2">
                    <h4 className="m-0 fw-bold themeBlue">Dropoff Details</h4>
                  </div>
                  <Row className="border-bottom">
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Name
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.dropOff?.dropOffContactName}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Contact Number:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.dropOff?.dropOffContactNumber}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Drop off Location
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.dropOff?.address}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Drop off Date
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {moment(data?.dropOff?.dropOffDate).format(
                            "MM/DD/YYYY"
                          )}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Drop off Time
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {moment(
                            data?.dropOff?.dropOffTime,
                            "HH:mm:ss"
                          ).format("hh:mm A")}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          {data?.bookingTypeRequest === "normal" ? "Total Amount" : "Bid Amount"}
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          ${data?.totalOffer}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Offer Amount
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          ${data?.bidAmount}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              {/* // images */}
              {/* {data?.serviceType !== "Towing" && (
                <div className="py-2">
                  <h6 className="m-0 fw-bold themeBLue">Images:</h6>
                  <Row>
                    <Col sm="12" className="my-2">
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        {data?.image?.map((image, index) => (
                          <img
                            src={image}
                            alt={`image-${index}`}
                            key={index}
                            className="img-fluid"
                            style={{
                              marginBottom: "10px",
                              height: 100,
                              width: 100,
                            }}
                          />
                        ))}
                      </div>
                    </Col>
                  </Row>
                </div>
              )} */}

              {/* // service start image */}
              {/* {data?.serviceType !== "Towing" && (
              <div className="py-2">
                <h6 className="m-0 fw-bold themeBLue">Pickup Image:</h6>
                <Row>
                  <Col sm="12" className="my-2">
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                      }}
                    >
                        {data?.serviceStartImage &&
                        data.serviceStartImage.length > 0 ? (
                          data.serviceStartImage.map((image, index) => (
                            <img
                              src={image}
                              alt={`image-${index}`}
                              key={index}
                              className="img-fluid"
                              style={{
                                marginBottom: "10px",
                                height: 100,
                                width: 100,
                              }}
                            />
                          ))
                      ) : (
                        <img
                          src={p1}
                          alt="dummy-image"
                          className="img-fluid"
                          style={{
                            marginBottom: "10px",
                            height: 100,
                            width: 100,
                          }}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
)} */}

              {/* // service end image */}
              {/* {data?.serviceType !== "Towing" && (
              <div className="py-2">
                <h6 className="m-0 fw-bold themeBLue">Dropoff Image:</h6>
                <Row>
                  <Col sm="12" className="my-2">
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                      }}
                    >
                      {data?.serviceEndImage &&
                      data.serviceEndImage.length > 0 ? (
                        data.serviceEndImage.map((image, index) => (
                          <img
                            src={image}
                            alt={`image-${index}`}
                            key={index}
                            className="img-fluid"
                            style={{
                              marginBottom: "10px",
                              height: 100,
                              width: 100,
                            }}
                          />
                        ))
                      ) : (
                        <img
                          src={p1}
                          alt="drop-image"
                          className="img-fluid"
                          style={{
                            marginBottom: "10px",
                            height: 100,
                            width: 100,
                          }}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
)} */}
            </Col>

            <Col lg="12" className="my-2">
              {data?.serviceType === "Towing" ? (
                <div className="py-2">
                  <div className="cardCstm p-3 rounded bg-white">
                    <div className="head m-0 mb-2">
                      <h4 className="m-0 fw-bold themeBlue">Vehicle Details</h4>
                    </div>
                    <Row className="border-bottom">
                      <Col md="4" className="">
                        <div className="inner h-100 border-bottom pb-2">
                          <label
                            htmlFor=""
                            className="m-0 form-label themeBlue m-0"
                          >
                            Vehicle license plate number:
                          </label>
                          <p className="m-0 fw-bold themeClr">
                            {data?.towingVehicleDetails?.licensePlateNumber}
                          </p>
                        </div>
                      </Col>
                      <Col md="4" className="">
                        <div className="inner h-100 border-bottom pb-2">
                          <label
                            htmlFor=""
                            className="m-0 form-label themeBlue m-0"
                          >
                            Vehicle make:
                          </label>
                          <p className="m-0 fw-bold themeClr">
                            {data?.towingVehicleDetails?.make}
                          </p>
                        </div>
                      </Col>
                      <Col md="4" className="">
                        <div className="inner h-100 border-bottom pb-2">
                          <label
                            htmlFor=""
                            className="m-0 form-label themeBlue m-0"
                          >
                            Vehicle model:
                          </label>
                          <p className="m-0 fw-bold themeClr">
                            {data?.towingVehicleDetails?.model}
                          </p>
                        </div>
                      </Col>
                      <Col md="4" className="">
                        <div className="inner h-100 border-bottom pb-2">
                          <label
                            htmlFor=""
                            className="m-0 form-label themeBlue m-0"
                          >
                            Vehicle color:
                          </label>
                          <p className="m-0 fw-bold themeClr">
                            {data?.towingVehicleDetails?.color}
                          </p>
                        </div>
                      </Col>
                      {/* <Col md="12" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Vehicle condition:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.towingVehicleDetails?.condition}
                        </p>
                      </div>
                    </Col> */}
                    </Row>
                    <div className="py-2">
                      <h6 className="m-0 fw-bold themeBLue">Vehicle Images:</h6>
                      <Row>
                        {/* <Col sm="6" className="my-2">
                        <img
                          src={p1}
                          alt=""
                          className="img-fluid w-100 rounded"
                        />
                      </Col> */}
                        <Col sm="6" className="my-2">
                          <img
                            src={data?.towingVehicleDetails?.image}
                            alt=""
                            className="img-fluid w-50 h-50 rounded"
                            onClick={() =>
                              handleImageClick(
                                data?.towingVehicleDetails?.image || p1
                              )
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <ImagePreview
                            showModal={showModalView}
                            selectedImage={selectedImage}
                            onClose={handleModalClose}
                          // title="Vehicle Image Preview"
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="py-2">
                  <div className="cardCstm p-3 rounded bg-white">
                    <div className="py-2">
                      <h6
                        className="m-0 fw-bold themeBLue"
                        style={{ paddingLeft: "15px" }}
                      >
                        Images:
                      </h6>
                      <Row>
                        <Col sm="6" className="my-2">
                          <div
                            style={{
                              // display: "flex",
                              // flexWrap: "wrap",
                              // gap: "10px",

                              display: "grid",
                              gridTemplateColumns: "repeat(2, 1fr)",
                              flexWrap: "nowrap",
                              gap: "40px",
                              width: "max-content",
                              paddingLeft: "15px",
                            }}
                          >
                            {data?.image?.map((image, index) => (
                              <img
                                src={image}
                                alt={`image-${index}`}
                                key={index}
                                className="img-fluid"
                                style={{
                                  marginBottom: "10px",
                                  height: 100,
                                  width: 100,
                                }}
                              />
                            ))}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              )}
            </Col>
            <Row>
              {/*               {!!data?.status &&
                data?.status !== "confirmed" &&
                !data?.bidAmount && (
                  <>
                    <Col lg="4" className="col-6 my2">
                      <Button
                        className="d-flex align-items-center justify-content-center commonBtn w-100"
                        type="button"
                        onClick={handleOffer}
                        // disabled={!!data?.bidAmount}
                      >
                        Accept
                      </Button>
                    </Col>
                    <Col lg="4" className="col-6">
                      <Button
                        className="d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
                        type="button"
                        onClick={(e) => acceptRejectHandler("reject")}
                      >
                        Reject
                      </Button>
                    </Col>
                  </>
                )}
*/}
              {!!data?.status &&
                data?.status !== "confirmed" &&
                !data?.bidAmount && (
                  <>
                    {
                      data?.bookingTypeRequest !== "normal" ?
                        <Col lg="4" className="col-6 my2">
                          <Button
                            className="d-flex align-items-center justify-content-center commonBtn w-100"
                            type="button"
                            onClick={handleOffer}
                          // disabled={!!data?.bidAmount}
                          >
                            Make Offer
                          </Button>
                        </Col>

                        :

                        <Col lg="4" className="col-6">
                          <Button
                            className="d-flex align-items-center justify-content-center commonBtn w-100 "
                            type="button"
                            onClick={(e) => acceptRejectHandler("accept")}
                          >
                            Accept
                          </Button>
                        </Col>
                    }
                    <Col lg="4" className="col-6">
                      <Button
                        className="d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
                        type="button"
                        onClick={(e) => acceptRejectHandler("reject")}
                      >
                        Reject
                      </Button>
                    </Col>

                  </>)}
            </Row>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageBookingDetail;
